export const THREAD_SCROLL_OPEN = 'open';
export const THREAD_SCROLL_LIVE = 'live';

export function threadScrollBehavior(reason) {
  return reason === THREAD_SCROLL_LIVE ? 'smooth' : 'auto';
}

export function scrollToLatestMessage(endEl, reason = THREAD_SCROLL_OPEN) {
  if (!endEl || typeof endEl.scrollIntoView !== 'function') return;
  endEl.scrollIntoView({ behavior: threadScrollBehavior(reason) });
}

export function shouldPinThreadToLatest({ conversationId, messageCount, alreadyPinnedId }) {
  return Boolean(conversationId) && messageCount > 0 && alreadyPinnedId !== conversationId;
}

export function pinThreadScroller(scrollEl) {
  if (!scrollEl) return;
  scrollEl.scrollTop = scrollEl.scrollHeight;
}
